module.exports = __webpack_public_path__ + "img/business-work.55297272.jpg";